import { render, staticRenderFns } from "./CongoRiver.vue?vue&type=template&id=2a767275&"
import script from "./CongoRiver.vue?vue&type=script&lang=js&"
export * from "./CongoRiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports